export default {
  hero: {
    pretitle: 'We are an',
    'second-pretitle': 'Independent creative agency',
    text: "<span class='break-indipendent'>Indepen</span> <span class='break-indipendent'>dent</span> <br /><span class='accent'>creative</span><br /> agency",
    overlapText:
      "With an <br /><span class='accent'>entrepreneurial</span><br /> mindset",
  },
}
